import { render } from "./EditorComments.vue?vue&type=template&id=4c99b3de&scoped=true"
import script from "./EditorComments.vue?vue&type=script&lang=js"
export * from "./EditorComments.vue?vue&type=script&lang=js"

import "./EditorComments.vue?vue&type=style&index=0&id=4c99b3de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c99b3de"]])

export default __exports__